import React from 'react';
import moment from 'moment';

import NextCheckinInProgress from './NextCheckinInProgress';
import NextCheckinReady from './NextCheckinReady';

const NextCheckinMetrics = props => {
    if (!props.documents) {
        return null;
    }

    const docs = props.documents;

    let header = null;
    if (props.checkindate) {
        let checkinDate = moment(props.checkindate);
        header = (
            <p className="header">
                Current Status - All Practices
                <span className="subheader">
                    {checkinDate.format('MM/DD/YYYY')} ({checkinDate.fromNow()})
                </span>
            </p>
        );
    }

    return (
        <div className="NextCheckinMetrics">
            {header}

            <NextCheckinInProgress documents={docs} />
            <NextCheckinReady documents={docs} />
        </div>
    );
};

export default NextCheckinMetrics;
